import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_HOST;


export const getMileStone = async ({ limit = 10, page = 1,search="" }) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/milestone`, {
   params: { limit, page, search },
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const addMilestone = async (data) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.post(
    `${API_BASE_URL}/milestone/add`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};



export const updateMileStone = async (payload) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.post(
    `${API_BASE_URL}/milestone/update`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data; 
};


export const getMilestoneById = async (id) => {
  const token = localStorage.getItem("access_token");

  try {
    const response = await axios.get(`${API_BASE_URL}/milestone/show/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const deleteMileStone = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/milestone/delete/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};


